import $ from 'jquery';
window.$ = window.jQuery = $;


import {Collapse, Carousel} from 'bootstrap';
